import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  oAuthGoogleGuardarToken
} from "@fixeduy/restaurantestypes";

const oAuthGoogleGuardarTokenFunction = async (
  params: oAuthGoogleGuardarToken
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({ func: "oAuthGoogleGuardarToken", params: params });
  return result.data;
};

export { oAuthGoogleGuardarTokenFunction };
